import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NotFound from '@pages/NotFound';
import useTheme from '@common/hooks/useTheme';

// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import RouteWithSubRoutes from './RouteWithSubRoutes';

// eslint-disable-next-line react/prop-types
function RenderRoutes({ routes }) {

  useTheme();

  return (
    <Switch>
      {/* eslint-disable-next-line react/prop-types */}
      {routes.map((item) => {
        const { menuItem, key, ...route } = item;
        return <RouteWithSubRoutes key={key} {...route} />;

      })}

      <Route path="/404" render={(props) => <NotFound {...props} />} />
      <Route render={(props) => <NotFound {...props} />} />
    </Switch>
  );

}

export default RenderRoutes;
